import posthog from "posthog-js";
import { useMyUser } from "@/hooks/auth/use-my-user";

export const useAnalytics = () => {
  const { myUser } = useMyUser();

  const capture = (event: string, properties?: Record<string, unknown>) => {
    const currentApp = myUser?.current_user?.data?.pylo_app?.data; // new schema
    posthog.capture(event, {
      ...properties,
      $groups: {
        pylo_customer: currentApp?.pylo_customer?.data?.id,
      },
      pylo_customer_id: currentApp?.pylo_customer?.data?.id,
      pylo_customer_name: currentApp?.pylo_customer?.data?.name,
      pylo_user_id: myUser?.current_user?.data?.id,
    });
  };

  return {
    capture,
  };
};
